module.exports = __webpack_public_path__ + "img/futures.8af3977b.png";